// 导入编辑组件
import QuestionEditSCQ from "@/components/QuestionEdit/QuestionEditSCQ.vue";
import QuestionEditMCQ from "@/components/QuestionEdit/QuestionEditMCQ.vue";
import QuestionEditDLQ from "@/components/QuestionEdit/QuestionEditDLQ.vue";
import QuestionEditVote from "@/components/QuestionEdit/QuestionEditVote.vue";
import QuestionEditSort from "@/components/QuestionEdit/QuestionEditSort.vue";
import QuestionEditSBQ from "@/components/QuestionEdit/QuestionEditSBQ.vue";
import QuestionEditMBQ from "@/components/QuestionEdit/QuestionEditMBQ.vue";
import QuestionEditQA from "@/components/QuestionEdit/QuestionEditQA.vue";
import QuestionEditGender from "@/components/QuestionEdit/QuestionEditGender.vue";
import QuestionEditAge from "@/components/QuestionEdit/QuestionEditAge.vue";
import QuestionEditNPS from "@/components/QuestionEdit/QuestionEditNPS.vue";
import QuestionEditRemark from "@/components/QuestionEdit/QuestionEditRemark.vue";
import QuestionEditScore from "@/components/QuestionEdit/QuestionEditScore.vue";
import QuestionEditName from "@/components/QuestionEdit/QuestionEditName.vue";
import QuestionEditEmail from "@/components/QuestionEdit/QuestionEditEmail.vue";
import QuestionEditTel from "@/components/QuestionEdit/QuestionEditTel.vue";
import QuestionEditTime from "@/components/QuestionEdit/QuestionEditTime.vue";
import QuestionEditDate from "@/components/QuestionEdit/QuestionEditDate.vue";
import QuestionEditWRQ from "@/components/QuestionEdit/QuestionEditWRQ.vue";
import QuestionEditSRQ from "@/components/QuestionEdit/QuestionEditSRQ.vue";
import QuestionEditAddress from "@/components/QuestionEdit/QuestionEditAddress.vue";
import QuestionEditImage from "@/components/QuestionEdit/QuestionEditImage.vue";
import QuestionEditMaxDiff from "@/components/QuestionEdit/QuestionEditMaxDiff.vue";
import QuestionEditUploadFile from "@/components/QuestionEdit/QuestionEditUploadFile.vue";
import QuestionEditDownloadFile from "@/components/QuestionEdit/QuestionEditDownloadFile.vue";
import QuestionEditCASCADER from "@/components/QuestionEdit/QuestionEditCASCADER.vue";
import QuestionEditBDQ from "@/components/QuestionEdit/QuestionEditBDQ.vue";
import QuestionEditIDQ from "@/components/QuestionEdit/QuestionEditIDQ.vue";
import QuestionEditELQ from "@/components/QuestionEdit/QuestionEditELQ.vue";
import QuestionEditWX from "@/components/QuestionEdit/QuestionEditWX.vue";
import QuestionEditTitle from "@/components/QuestionEdit/QuestionEditTitle.vue";
import QuestionEditImageMcq from "@/components/QuestionEdit/QuestionEditImageMcq.vue";
import QuestionEditImageOrVideo from "@/components/QuestionEdit/QuestionEditImageOrVideo.vue";
import QuestionEditImageScq from "@/components/QuestionEdit/QuestionEditImageScq.vue";
import QuestionEditMatrixMcq from "@/components/QuestionEdit/QuestionEditMatrixMcq.vue";
import QuestionEditMatrixScq from "@/components/QuestionEdit/QuestionEditMatrixScq.vue";
import QuestionEditPageBreak from "@/components/QuestionEdit/QuestionEditPageBreak.vue";
import QuestionEditSignature from "@/components/QuestionEdit/QuestionEditSignature.vue";

import QuestionPreviewSCQ from "@/components/QuestionPreview/QuestionPreviewSCQ.vue";
import QuestionPreviewMCQ from "@/components/QuestionPreview/QuestionPreviewMCQ.vue";
import QuestionPreviewDLQ from "@/components/QuestionPreview/QuestionPreviewDLQ.vue";
import QuestionPreviewVote from "@/components/QuestionPreview/QuestionPreviewVote.vue";
import QuestionPreviewSort from "@/components/QuestionPreview/QuestionPreviewSort.vue";
import QuestionPreviewSBQ from "@/components/QuestionPreview/QuestionPreviewSBQ.vue";
import QuestionPreviewMBQ from "@/components/QuestionPreview/QuestionPreviewMBQ.vue";
import QuestionPreviewQA from "@/components/QuestionPreview/QuestionPreviewQA.vue";
import QuestionPreviewGender from "@/components/QuestionPreview/QuestionPreviewGender.vue";
import QuestionPreviewAge from "@/components/QuestionPreview/QuestionPreviewAge.vue";
import QuestionPreviewNPS from "@/components/QuestionPreview/QuestionPreviewNPS.vue";
import QuestionPreviewRemark from "@/components/QuestionPreview/QuestionPreviewRemark.vue";
import QuestionPreviewScore from "@/components/QuestionPreview/QuestionPreviewScore.vue";
import QuestionPreviewName from "@/components/QuestionPreview/QuestionPreviewName.vue";
import QuestionPreviewEmail from "@/components/QuestionPreview/QuestionPreviewEmail.vue";
import QuestionPreviewTel from "@/components/QuestionPreview/QuestionPreviewTel.vue";
import QuestionPreviewTime from "@/components/QuestionPreview/QuestionPreviewTime.vue";
import QuestionPreviewDate from "@/components/QuestionPreview/QuestionPreviewDate.vue";
import QuestionPreviewWRQ from "@/components/QuestionPreview/QuestionPreviewWRQ.vue";
import QuestionPreviewSRQ from "@/components/QuestionPreview/QuestionPreviewSRQ.vue";
import QuestionPreviewAddress from "@/components/QuestionPreview/QuestionPreviewAddress.vue";
import QuestionPreviewImage from "@/components/QuestionPreview/QuestionPreviewImage.vue";
import QuestionPreviewMaxDiff from "@/components/QuestionPreview/QuestionPreviewMaxDiff.vue";
import QuestionPreviewUploadFile from "@/components/QuestionPreview/QuestionPreviewUploadFile.vue";
import QuestionPreviewDownloadFile from "@/components/QuestionPreview/QuestionPreviewDownloadFile.vue";
import QuestionPreviewCASCADER from "@/components/QuestionPreview/QuestionPreviewCASCADER.vue";
import QuestionPreviewBDQ from "@/components/QuestionPreview/QuestionPreviewBDQ.vue";
import QuestionPreviewIDQ from "@/components/QuestionPreview/QuestionPreviewIDQ.vue";
import QuestionPreviewELQ from "@/components/QuestionPreview/QuestionPreviewELQ.vue";
import QuestionPreviewWX from "@/components/QuestionPreview/QuestionPreviewWX.vue";
import QuestionPreviewTitle from "@/components/QuestionPreview/QuestionPreviewTitle.vue";
import QuestionPreviewImageMcq from "@/components/QuestionPreview/QuestionPreviewImageMcq.vue";
import QuestionPreviewMatrixMcq from "@/components/QuestionPreview/QuestionPreviewMatrixMcq.vue";
import QuestionPreviewMatrixScq from "@/components/QuestionPreview/QuestionPreviewMatrixScq.vue";
import QuestionPreviewPageBreak from "@/components/QuestionPreview/QuestionPreviewPageBreak.vue";
import QuestionPreviewSignature from "@/components/QuestionPreview/QuestionPreviewSignature.vue";
import QuestionPreviewImageScq from "@/components/QuestionPreview/QuestionPreviewImageScq.vue";
import QuestionPreviewImageOrVideo from "@/components/QuestionPreview/QuestionPreviewImageOrVideo.vue";

import ExamEditSCQ from "@/components/ExamEdit/ExamEditSCQ.vue";
import ExamEditMCQ from "@/components/ExamEdit/ExamEditMCQ.vue";
import ExamEditSBQ from "@/components/ExamEdit/ExamEditSBQ.vue";
import ExamEditMBQ from "@/components/ExamEdit/ExamEditMBQ.vue";
import ExamEditQA from "@/components/ExamEdit/ExamEditQA.vue";
import ExamEditIMAGE from "@/components/ExamEdit/ExamEditIMAGE.vue";
import ExamEditTFQ from "@/components/ExamEdit/ExamEditTFQ.vue";
import ExamEditClozeTest from "@/components/ExamEdit/ExamEditClozeTest.vue";

import ExamPreviewSCQ from "@/components/ExamPreview/ExamPreviewSCQ.vue";
import ExamPreviewMCQ from "@/components/ExamPreview/ExamPreviewMCQ.vue";
import ExamPreviewSBQ from "@/components/ExamPreview/ExamPreviewSBQ.vue";
import ExamPreviewMBQ from "@/components/ExamPreview/ExamPreviewMBQ.vue";
import ExamPreviewQA from "@/components/ExamPreview/ExamPreviewQA.vue";
import ExamPreviewIMAGE from "@/components/ExamPreview/ExamPreviewIMAGE.vue";
import ExamPreviewTFQ from "@/components/ExamPreview/ExamPreviewTFQ.vue";
import ExamPreviewClozeTest from "@/components/ExamPreview/ExamPreviewClozeTest.vue";

import EvaluationEditSCQ from "@/components/EvaluationEdit/EvaluationEditSCQ.vue";
import EvaluationEditMCQ from "@/components/EvaluationEdit/EvaluationEditMCQ.vue";
import EvaluationEditNPS from "@/components/EvaluationEdit/EvaluationEditNPS.vue";
import EvaluationEditScore from "@/components/EvaluationEdit/EvaluationEditScore.vue";
import EvaluationEditWRQ from "@/components/EvaluationEdit/EvaluationEditWRQ.vue";
import EvaluationEditDesc from "@/components/EvaluationEdit/EvaluationEditDesc.vue";
import EvaluationEditName from "@/components/EvaluationEdit/EvaluationEditName.vue";
import EvaluationEditAge from "@/components/EvaluationEdit/EvaluationEditAge.vue";
import EvaluationEditAddress from "@/components/EvaluationEdit/EvaluationEditAddress.vue";
import EvaluationEditDate from "@/components/EvaluationEdit/EvaluationEditDate.vue";
import EvaluationEditELQ from "@/components/EvaluationEdit/EvaluationEditELQ.vue";
import EvaluationEditGender from "@/components/EvaluationEdit/EvaluationEditGender.vue";
import EvaluationEditIndustry from "@/components/EvaluationEdit/EvaluationEditIndustry.vue";
import EvaluationEditOccupation from "@/components/EvaluationEdit/EvaluationEditOccupation.vue";

import EvaluationPreviewSCQ from "@/components/EvaluationPreview/EvaluationPreviewSCQ.vue";
import EvaluationPreviewMCQ from "@/components/EvaluationPreview/EvaluationPreviewMCQ.vue";
import EvaluationPreviewNPS from "@/components/EvaluationPreview/EvaluationPreviewNPS.vue";
import EvaluationPreviewScore from "@/components/EvaluationPreview/EvaluationPreviewScore.vue";
import EvaluationPreviewWRQ from "@/components/EvaluationPreview/EvaluationPreviewWRQ.vue";
import EvaluationPreviewDesc from "@/components/EvaluationPreview/EvaluationPreviewDesc.vue";
import EvaluationPreviewName from "@/components/EvaluationPreview/EvaluationPreviewName.vue";
import EvaluationPreviewAge from "@/components/EvaluationPreview/EvaluationPreviewAge.vue";
import EvaluationPreviewAddress from "@/components/EvaluationPreview/EvaluationPreviewAddress.vue";
import EvaluationPreviewDate from "@/components/EvaluationPreview/EvaluationPreviewDate.vue";
import EvaluationPreviewELQ from "@/components/EvaluationPreview/EvaluationPreviewELQ.vue";
import EvaluationPreviewGender from "@/components/EvaluationPreview/EvaluationPreviewGender.vue";
import EvaluationPreviewIndustry from "@/components/EvaluationPreview/EvaluationPreviewIndustry.vue";
import EvaluationPreviewOccupation from "@/components/EvaluationPreview/EvaluationPreviewOccupation.vue";

// 导出编辑组件
export const EditComponents = {
  QuestionEditSCQ,
  QuestionEditDLQ,
  QuestionEditVote,
  QuestionEditSort,
  QuestionEditSBQ,
  QuestionEditMBQ,
  QuestionEditQA,
  QuestionEditGender,
  QuestionEditAge,
  QuestionEditNPS,
  QuestionEditRemark,
  QuestionEditScore,
  QuestionEditName,
  QuestionEditEmail,
  QuestionEditTel,
  QuestionEditTime,
  QuestionEditDate,
  QuestionEditWRQ,
  QuestionEditSRQ,
  QuestionEditMCQ,
  QuestionEditAddress,
  QuestionEditImage,
  QuestionEditMaxDiff,
  QuestionEditUploadFile,
  QuestionEditDownloadFile,
  QuestionEditCASCADER,
  QuestionEditBDQ,
  QuestionEditIDQ,
  QuestionEditELQ,
  QuestionEditWX,
  QuestionEditTitle,
  QuestionEditImageMcq,
  QuestionEditImageOrVideo,
  QuestionEditImageScq,
  QuestionEditMatrixMcq,
  QuestionEditMatrixScq,
  QuestionEditPageBreak,
  QuestionEditSignature,
  ExamEditSCQ,
  ExamEditMCQ,
  ExamEditSBQ,
  ExamEditMBQ,
  ExamEditQA,
  ExamEditIMAGE,
  ExamEditTFQ,
  ExamEditClozeTest,
  EvaluationEditSCQ,
  EvaluationEditMCQ,
  EvaluationEditNPS,
  EvaluationEditScore,
  EvaluationEditWRQ,
  EvaluationEditDesc,
  EvaluationEditName,
  EvaluationEditAge,
  EvaluationEditAddress,
  EvaluationEditDate,
  EvaluationEditELQ,
  EvaluationEditGender,
  EvaluationEditIndustry,
  EvaluationEditOccupation,
};

// 导出预览组件
export const PreviewComponents = {
  QuestionPreviewSCQ,
  QuestionPreviewDLQ,
  QuestionPreviewVote,
  QuestionPreviewSort,
  QuestionPreviewSBQ,
  QuestionPreviewMBQ,
  QuestionPreviewQA,
  QuestionPreviewGender,
  QuestionPreviewAge,
  QuestionPreviewNPS,
  QuestionPreviewRemark,
  QuestionPreviewScore,
  QuestionPreviewName,
  QuestionPreviewEmail,
  QuestionPreviewTel,
  QuestionPreviewTime,
  QuestionPreviewDate,
  QuestionPreviewWRQ,
  QuestionPreviewSRQ,
  QuestionPreviewMCQ,
  QuestionPreviewAddress,
  QuestionPreviewImage,
  QuestionPreviewMaxDiff,
  QuestionPreviewUploadFile,
  QuestionPreviewDownloadFile,
  QuestionPreviewCASCADER,
  QuestionPreviewBDQ,
  QuestionPreviewIDQ,
  QuestionPreviewELQ,
  QuestionPreviewWX,
  QuestionPreviewTitle,
  QuestionPreviewImageMcq,
  QuestionPreviewImageOrVideo,
  QuestionPreviewImageScq,
  QuestionPreviewMatrixMcq,
  QuestionPreviewMatrixScq,
  QuestionPreviewPageBreak,
  QuestionPreviewSignature,
  ExamPreviewSCQ,
  ExamPreviewMCQ,
  ExamPreviewSBQ,
  ExamPreviewMBQ,
  ExamPreviewQA,
  ExamPreviewIMAGE,
  ExamPreviewTFQ,
  ExamPreviewClozeTest,
  EvaluationPreviewSCQ,
  EvaluationPreviewMCQ,
  EvaluationPreviewNPS,
  EvaluationPreviewScore,
  EvaluationPreviewWRQ,
  EvaluationPreviewDesc,
  EvaluationPreviewName,
  EvaluationPreviewAge,
  EvaluationPreviewAddress,
  EvaluationPreviewDate,
  EvaluationPreviewELQ,
  EvaluationPreviewGender,
  EvaluationPreviewIndustry,
  EvaluationPreviewOccupation,
};

// 导出所有组件
export default {
  ...EditComponents,
  ...PreviewComponents,
};



// WEBPACK FOOTER //
// ./src/utils/componentImports.js